import React from "react";
import styled, { css } from "styled-components";
import { FlexColumn } from "../../";
export const ToggleOption = ({
  icon,
  onClick,
  active,
  editorFocus
}) => {
  return /*#__PURE__*/React.createElement(ToolbarOptionContainer, {
    xCenter: true,
    yCenter: true,
    onMouseDown: editorFocus ? e => {
      e.preventDefault();
      onClick();
    } : undefined,
    active: active,
    hasFocus: editorFocus
  }, icon);
};
const ToolbarOptionContainer = styled(FlexColumn)`
  border-radius: 4px;
  width: 40px;
  height: 40px;
  position: relative;
  z-index: 1;
  & + & {
    margin-left: 4px;
  }
  svg path {
    fill: ${props => props.theme.palette.gray.lighter};
  }
  ${props => props.hasFocus && css`
      &:hover {
        svg path {
          fill: ${props => !props.active && props.theme.palette.gray.primary};
        }
        background: #f5f5f5;
        cursor: pointer;
      }
      svg path {
        fill: ${props => props.theme.palette.gray.primary};
      }
    `};
  ${props => props.active && css`
      svg path {
        fill: #222222;
      }
      background: ${props => props.theme.palette.gray.lightest};
      &:hover {
        background: ${props => props.theme.palette.gray.lightest};
      }
    `};
  @media only screen and ${props => props.theme.media.small} {
    margin-left: 0;
    & + & {
      margin-left: 4px;
    }
    ${props => props.forDesktop && css`
        display: none;
      `};
  }
`;